<template>
  <div class="payment-instance py-2 border-bottom">
    <div class="payment-instance-name d-flex align-items-center justify-content-between">
      <span class="fw-bold">{{ instance.name }}</span>
      <span v-if="!isCcPool" class="badge bg-secondary">Non-CC</span>
    </div>

    <div class="payment-instance-controls d-flex align-items-center justify-content-between mt-2">
      <div v-if="isCcPool" class="payment-value-group">
        <div class="d-flex align-items-center">
          <input
              type="number"
              min="0"
              max="100"
              class="form-control form-control-sm payment-value-input"
              :value="instance.percentage"
              :disabled="!instance.active"
              @focus="showRemaining = true"
              @blur="showRemaining = false"
              @input="onPercentageChange($event)"
          >
          <span class="ms-1">%</span>
        </div>
        <div v-if="showRemaining" class="payment-remaining-hint">{{ remaining }}% left</div>
      </div>
      <span v-else></span>

      <ToggleSwitch :model-value="instance.active" @update:model-value="setActive" />
    </div>

    <div v-if="hasWhatsappFlag" class="d-flex align-items-center justify-content-between mt-2">
      <span class="text-muted small">WhatsApp share</span>
      <span class="badge" :class="instance.whatsappEnabled ? 'bg-success' : 'bg-light text-muted border'">
        {{ instance.whatsappEnabled ? 'Enabled' : 'Disabled' }}
      </span>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from "@/components/ToggleSwitch.vue";

export default {
  name: "PaymentMethodInstance",
  components: { ToggleSwitch },
  props: {
    instance: {
      type: Object,
      required: true
    },
    // Sum of every active CC instance's percentage across all providers, passed down from
    // the page. Used only to show the "X% left" reminder below the field — purely
    // informational, it never limits what can be typed here.
    ccTotal: {
      type: Number,
      default: 0
    }
  },
  emits: ["update-active", "update-percentage"],
  data() {
    return {
      showRemaining: false
    };
  },
  computed: {
    // The rule that decides CC vs non-CC: a numeric percentage means this row shares the
    // Credit Card pool. null/undefined (Plisio) means it's outside the pool entirely.
    isCcPool() {
      return this.instance.percentage !== null && this.instance.percentage !== undefined;
    },
    // Only cPay rows carry this field (see PaymentManagement.vue's buildProviders) — every
    // other provider leaves it undefined, so the row is hidden everywhere else.
    hasWhatsappFlag() {
      return this.instance.whatsappEnabled !== undefined && this.instance.whatsappEnabled !== null;
    },
    // Unallocated headroom in the pool, excluding this instance's own current value —
    // shown as a reminder while editing, never used to cap the input.
    remaining() {
      if (!this.isCcPool) return 0;
      const ownContribution = this.instance.active ? (this.instance.percentage || 0) : 0;
      const othersTotal = this.ccTotal - ownContribution;
      return Math.max(0, 100 - othersTotal);
    }
  },
  methods: {
    setActive(value) {
      this.$emit("update-active", value);
    },
    onPercentageChange(event) {
      let value = parseInt(event.target.value, 10);
      if (isNaN(value)) value = 0;
      if (value < 0) value = 0;
      if (value > 100) value = 100;
      this.$emit("update-percentage", value);
    }
  }
}
</script>

<style scoped>
.payment-value-group {
  display: flex;
  flex-direction: column;
}
.payment-value-input {
  width: 70px;
}
.payment-remaining-hint {
  font-size: 0.75rem;
  color: #adb5bd;
  margin-top: 2px;
}
</style>
